/**
 * dmdilly API Functions
 * Self-contained API layer for dmdilly backend integration.
 */

async function apiCall(baseUrl, endpoint, options = {}) {
  try {
    const response = await fetch(`${baseUrl}${endpoint}`, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${window.localStorage.getItem('guideToken')}`,
        ...options.headers,
      },
      ...options,
    });

    const data = await response.json();

    if (!response.ok) {
      return { data: null, error: data.error || 'Request failed' };
    }

    return { data, error: null };
  } catch (error) {
    return { data: null, error: error.message || 'Network error' };
  }
}

// Creator Interview API
export function startCreatorInterview(baseUrl, creatorId) {
  return apiCall(baseUrl, '/creator-interview/start', {
    method: 'POST',
    body: JSON.stringify({ creatorId }),
  });
}

export function replyToInterview(baseUrl, sessionId, answer) {
  return apiCall(baseUrl, '/creator-interview/reply', {
    method: 'POST',
    body: JSON.stringify({ sessionId, message: answer }),
  });
}

// Creator Profile API
export function getCreatorProfile(baseUrl, creatorId) {
  return apiCall(baseUrl, `/creator-interview/profile/${creatorId}`);
}

// Fan Submission API
export function startFanSubmission(baseUrl, creatorId) {
  return apiCall(baseUrl, '/fan-submissions/start', {
    method: 'POST',
    body: JSON.stringify({ creatorId }),
  });
}

export function submitFanAnswers(baseUrl, sessionId, answers) {
  return apiCall(baseUrl, '/fan-submissions/submit', {
    method: 'POST',
    body: JSON.stringify({ sessionId, answers }),
  });
}

// Inbox API
export function getInbox(baseUrl, creatorId, status = null) {
  const params = status ? `?status=${status}` : '';
  return apiCall(baseUrl, `/fan-submissions/inbox/${creatorId}${params}`);
}

export function updateSubmissionStatus(baseUrl, submissionId, status) {
  return apiCall(baseUrl, `/fan-submissions/${submissionId}/status`, {
    method: 'PATCH',
    body: JSON.stringify({ status }),
  });
}
